import React, {useEffect, useState} from "react";
import {RouteComponentProps} from 'react-router-dom'
import Article, {ArticleType} from "../../api/model/Article";
import ArticleApi from "../../api/ArticleApi";
import './ArticleListPage.scss'
import moment from 'moment';
import Tag from "../../components/shared/Tag/Tag";
import {Config} from "../../config";

export default function ArticleListPage(props: IProps) {
    const type = props.match.params.type;
    const [list, setList] = useState<Article[]>([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize] = useState(10);
    const [loadMoreMessage, setLoadMoreMessage] = useState("加载更多");

    async function listArticle() {
        setLoadMoreMessage("加载中")
        const response = await ArticleApi.search({
            pi: pageIndex,
            ps: pageSize,
            type: type
        });
        if (response.list.length === 0) {
            setLoadMoreMessage("已加载全部")
        } else {
            setLoadMoreMessage("加载更多")
        }
        setList(list.concat(response.list))
    }

    function loadMore() {
        setPageIndex(pageIndex + 1);
    }

    function navigateToDetail(id: number) {
        props.history.push({
            pathname: '/article/detail/' + String(id),
        })
    }

    function navigateToMainPage() {
        props.history.push({
            pathname: '/'
        })
    }

    useEffect(() => {
        listArticle();
    }, [listArticle]);
    useEffect(() => {
        listArticle();
    }, [listArticle, pageIndex]);

    const sortedList = list.sort(i => i.isTop ? -1 : 1);
    return (
        <div className="ArticleListPage">
            <span className="breadcrumbs"><span style={{fontSize: 13}} onClick={() => {
                navigateToMainPage()
            }}>主页 / </span>{type}</span>
            {
                sortedList.map((item, index) => (
                    <div key={item.id} onClick={() => {
                        navigateToDetail(item.id)
                    }} style={{padding: 12}}>
                        <div className="row">
                            <div className="calendar">
                                <span className="calendar-date">{moment(item.createdTime).format("MM 月 DD 日 ")}</span>
                                <span className="calendar-year">{moment(item.createdTime).format("YYYY ddd ")}</span>
                            </div>
                            <div className="article-content">
                                <span>
                                    {item.isTop && <div className="tag" style={{marginRight: 4}}>
                                        <Tag text="置顶" color={Config.secondaryColor} textColor="#fff"/>
                                    </div>}
                                    <span>{item.title}</span>
                                </span>
                                <span className="article-subtitle">{item.description}</span>
                            </div>
                        </div>
                    </div>
                ))
            }
            <p className="load-more" onClick={() => {
                loadMore();
            }}>{loadMoreMessage}</p>
        </div>
    )
}

interface IProps extends RouteComponentProps<IQueryParams> {

}

interface IQueryParams {
    type: ArticleType
}
